import { ReactNode } from 'react';

import {
  DialogComposite,
  DialogControlledProps,
  DialogStaticProps,
} from '../DialogComposite';

export type RootProps = (
  | Omit<DialogControlledProps, 'children' | 'ref'>
  | Omit<DialogStaticProps, 'children' | 'ref'>
) & {
  children: ReactNode;
};

const Root = (props: RootProps) => {
  return <DialogComposite.Root {...props} />;
};

export default Root;
